import React, { useContext, useMemo } from 'react';

import AddPaymentMethodBox from './AddPaymentMethodBox';
import CardInfo from './CardInfo';
import { CardInfoProps } from './payment-methods-types';
import BillingService from '@/components/Billing/billing-service';
import { PaymentMethod } from '@/components/Billing/billing-types';
import { AppDivider } from '@/react_app/components/Atoms';
import AnimateView from '@/react_app/components/BillingUsage/AnimateView';
import { PaymentMethodContext } from '@/react_app/components/BillingUsage/contexts';

const SettingsUsageBillingPaymentMethods = () => {
	const contextValue = useContext(PaymentMethodContext);
	if (contextValue === null) {
		return null;
	}
	const { paymentMethods, defaultPaymentMethodId, paymentIdInLoadingToBeDefault, onDeletePaymentMethod, onSetDefaultPaymentMethod } =
		useMemo(() => contextValue, [contextValue]);

	const cardsProps: CardInfoProps[] = paymentMethods.map((paymentMethod: PaymentMethod) => ({
		sectionTitle: 'Billing contacts',
		isDefault: paymentMethod.id === defaultPaymentMethodId,
		cardInfo: BillingService.getPaymentMethodCard(paymentMethod),
		onDeletePaymentMethod: () => onDeletePaymentMethod(paymentMethod.id),
		isLoadingSetDefault: paymentIdInLoadingToBeDefault === paymentMethod.id,
		onSetDefaultPaymentMethod: () => onSetDefaultPaymentMethod(paymentMethod.id),
	}));

	return (
		<AnimateView>
			<div className="grid grid-cols-2 gap-12 max-w-6xl">
				<div>
					{cardsProps.map((cardProps: CardInfoProps, index) => (
						<React.Fragment key={index}>
							<CardInfo {...cardProps} />
							{index !== cardsProps.length - 1 && <AppDivider />}
						</React.Fragment>
					))}
				</div>
				<AddPaymentMethodBox />
			</div>
		</AnimateView>
	);
};

export default SettingsUsageBillingPaymentMethods;
